import React, { createContext, useContext, useState, ReactNode } from "react";

interface SectionContextType {
  sectionId: number;
  setSectionId: React.Dispatch<React.SetStateAction<number>>;
}

const SectionContext = createContext<SectionContextType | null>(null);

export const SectionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [sectionId, setSectionId] = useState<number>(0);

  return <SectionContext.Provider value={{ sectionId, setSectionId }}>{children}</SectionContext.Provider>;
};

const useSection = (): SectionContextType => {
  const section = useContext(SectionContext) as SectionContextType;
  if (!section) {
    throw new Error("useSection must be used inside of SectionProvider");
  }
  return section;
};

export { useSection };
export default SectionContext;
